/*
 * File: previousOrders.ts
 * Project: meki
 * File Created: Tuesday, 16th November 2021 6:29:07 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Wednesday, 8th February 2023 4:04:29 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { gql } from '@apollo/client';
import { Order } from '@interfaces';
import { ResolverParams } from '@queries/queries.interfaces';
import { PageInfo } from '@interfaces';

export const previousOrdersQuery = (name: string) => gql`
  query ${name}($params: GetOrdersParams) {
    orders(params: $params) {
      nodes {
        id
        uuid
        orderGroupId
        onDemand
        address {
          name
          street
          streetNumber
        }
        status
        deliveryCost
        deliveryDate
        deliveryType
        paidAt
        payments {
          id
          amount
          paymentMethodType
          status
        }
        orderDetails(allowZero: true) {
          id
          uuid
          price
          quantity
          requestedQuantity
          returnedQuantity
          product {
            id
            name
            quantity
            concentration
          }
        }
        orderInsurance {
          id
        }
      }
      pageInfo {
        hasNextPage
        pageNumber
        hasPreviousPage
        totalPages
      }
      totalCount
    }
  }
`;

export type PreviousOrdersQueryResponse = {
  orders: {
    nodes: Pick<
      Order,
      | 'uuid'
      | 'id'
      | 'address'
      | 'status'
      | 'deliveryCost'
      | 'deliveryDate'
      | 'orderDetails'
      | 'orderGroupId'
      | 'onDemand'
      | 'deliveryType'
      | 'paidAt'
      | 'payments'
      | 'orderInsurance'
    >[];
    pageInfo: PageInfo;
    totalCount?: number;
  };
};
export type OrdersQueryParams = ResolverParams<{
  fromDate?: string;
  pageNumber: number;
}>;
